import { createIcon } from '@chakra-ui/react'

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  path: (
    <>
      <path
        d='M10.6666 8.16645L3.16656 8.16645L3.16656 7.83312L10.6666 7.83312L11.8737 7.83312L11.0201 6.97957L7.707 3.66645L7.94656 3.42689L12.5195 7.99979L7.94656 12.5727L7.707 12.3331L11.0201 9.02L11.8737 8.16645L10.6666 8.16645Z'
        fill='#CDD5DF'
        stroke='#748094'
      />
    </>
  ),
  viewBox: '0 0 16 16',
})
